import { Box, Text, useMantineTheme } from '@mantine/core';
import { Button, Collapse } from '@vrplatform/components';
import type { ReactNode } from 'react';

export const ReservationSectionJumpTo = ({
  title,
  count,
  goToTab,
}: {
  title: string;
  count: ReactNode;
  goToTab: () => void;
}) => {
  const theme = useMantineTheme();

  return (
    <Box>
      <Collapse
        title={
          <Text component="span" size="sm" fw={500}>
            {title}
            <Text c={'gray'} ml="xs" size="xs" component="span">
              {count}
            </Text>
          </Text>
        }
        spacing={0}
        rightSection={
          <Button
            variant="light"
            size="xs"
            rightIcon="ArrowRightIcon"
            color="neutral"
            iconColor={theme.colors.neutral[5]}
            onClick={goToTab}
          >
            View data
          </Button>
        }
        hideToggle
      />
    </Box>
  );
};
